import React from 'react';
import { Text, TextTypography } from 'wix-ui-tpa/cssVars';

import MenuSection from '../MenuSection';
import EmptyState from '../EmptyState';

import { classes, st } from './MenuList.st.css';
import { menuListDataHooks } from './constants';
import { useHooks } from './useHooks';

type MenuListProps = {
  className?: string;
};

const MenuList: React.FC<MenuListProps> = ({ className }) => {
  const { menus, layoutSize, showMenuDescription, showMenuDivider } =
    useHooks();

  return (
    <div
      className={st(classes.root, { [layoutSize]: true }, className)}
      data-hook={menuListDataHooks.root()}
    >
      {menus.map((menu) => (
        <div key={menu.id} className={classes.menuBlock} data-menu-id={menu.id}>
          <div className={classes.menuHeader}>
            <Text
              className={classes.menuTitle}
              data-hook={menuListDataHooks.menuTitle()}
              typography={TextTypography.largeTitle}
              tagName="h2"
            >
              {menu.name}
            </Text>
            {showMenuDescription && menu.description && (
              <Text
                className={classes.menuDescription}
                data-hook={menuListDataHooks.menuDescription()}
                tagName="p"
              >
                {menu.description}
              </Text>
            )}
          </div>
          {menu.sections.length > 0 ? (
            <>
              {showMenuDivider && (
                <div
                  className={classes.divider}
                  data-hook={menuListDataHooks.divider()}
                  role="separator"
                />
              )}
              <div className={classes.sections}>
                {menu.sections.map((section) => (
                  <MenuSection
                    key={section.id}
                    section={section}
                    menuId={menu.id}
                  />
                ))}
              </div>
            </>
          ) : (
            <EmptyState />
          )}
        </div>
      ))}
    </div>
  );
};

export default MenuList;
